import { useParams, useNavigate } from 'react-router-dom'
import { useCallback } from 'react'
import { Stack, Button } from '@mui/material'
import BoardView from '@components/Board/BoardView'
import { useIsMobile } from '@/hooks/Responsive' 
import { fetchMngQnaDetail } from '@/api/mypage'
import { useAuth } from '@/components/AuthContext'

export default function MyQnaView() {
  const { REACT_APP_ADMIN_PAGE_PATH } = process.env;

  const { id } = useParams()
  const navigate = useNavigate()
  const { isMobile } = useIsMobile() 

  const { user, loading, isAuthReady } = useAuth();

  const fetcher = useCallback(async () => {
    try {
      const response = await fetchMngQnaDetail({ params: { bulletinId: id, accountId: user.accountId } });
      const data = response.data;
      return {
        id: data.bulletinId,
        isQna: true,
        qInstitution: data.institutionName,
        qDepartment: data.departmentName,
        qLecture: data.eduLectureName,
        writer: data.writerName,
        title: data.bulletinTitle,
        createdAt: data.registDttm,
        content: data.bulletinSubstatnce,
        answer: data.commentSubstatnce,
        attachments: data.attachments || [],
        answerattachments: data.answerAttachments || [],
      };
    } catch (error) {
      console.error("Failed to fetch Q&A detail:", error);
      return null;
    }
  }, [id]);

  return (
    <BoardView
      fetcher={fetcher}
      bottomToolbarRender={() => (
        <Stack direction="row" spacing={1} justifyContent="space-between">
          <Button
            variant="outlined"
            color="primary"
            size="large"
            href={REACT_APP_ADMIN_PAGE_PATH}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ width: isMobile ? '100%' : 'auto'}}
          >
            관리
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            sx={{ width: isMobile ? '100%' : 'auto'}} 
            onClick={() => navigate(-1)}
          >
            목록
          </Button>
        </Stack>
      )}
    />
  )
}